import { render } from "./ProfitAndLossPage.vue?vue&type=template&id=379d3252&scoped=true"
import script from "./ProfitAndLossPage.vue?vue&type=script&lang=js"
export * from "./ProfitAndLossPage.vue?vue&type=script&lang=js"

import "./ProfitAndLossPage.vue?vue&type=style&index=0&id=379d3252&lang=scss"
import "./ProfitAndLossPage.vue?vue&type=style&index=1&id=379d3252&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379d3252"]])

export default __exports__